var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.apiConfigFinished)?_c('div',{class:_vm.appClass,attrs:{"id":"app"}},[_c('style',{tag:"component"},[_vm._v(" "+_vm._s(_vm.rootVariables)+" ")]),_c('router-view',{staticClass:"main-wrapper"},[(_vm.highMaintenanceActive)?_c('HighMaintenance'):_vm._e()],1),_c('Zendesk')],1):_c('PageLoading')
}
var staticRenderFns = []

export { render, staticRenderFns }